import { Actions } from "bqx-deal";
import { Section } from "src/app/models/shared/section.model";

export abstract class AbstractDealAnalyticsService {
  abstract postDealPageEvent(page?: string, title?: string, handshakeGUID?: string): void;
  abstract postDealControlEvent(action: Actions, label: string, page?: string, title?: string, carrierName?: string, dataValue?:string, premiumAmount?: string): void;
  abstract get currentSection(): Section; 
}